"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formatters_1 = require("../utils/formatters");
var validator_1 = require("../utils/validator");
var Chart_1 = __importDefault(require("./Chart"));
var GraphSingleBlock = /** @class */ (function (_super) {
    __extends(GraphSingleBlock, _super);
    function GraphSingleBlock(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loading: true,
            data: undefined,
        };
        return _this;
    }
    GraphSingleBlock.prototype.componentDidMount = function () {
        var _this = this;
        fetch("/api/report/graph/".concat(this.props.blockId, "/").concat(this.props.languageBranch))
            .then(function (response) { return response.json(); })
            .then(function (data) {
            return _this.setState({
                data: data,
                loading: false,
            });
        });
    };
    GraphSingleBlock.prototype.render = function () {
        var _a = this.state, loading = _a.loading, data = _a.data;
        var palette = this.props.palette;
        if (loading) {
            return react_1.default.createElement("div", null, "Loading....");
        }
        var options = data.options;
        if (data.type === 'bar' ||
            data.type === 'horizontalBar' ||
            data.type === 'line') {
            options = (0, formatters_1.formatYAxes)(options);
            var nthTicks = data.drawEveryNthTickOnXAxis || 0;
            options =
                nthTicks != 0
                    ? (0, formatters_1.showNthTick)((0, formatters_1.formatTooltips)(options), nthTicks)
                    : (0, formatters_1.formatTooltips)(options);
        }
        var newDatasets = data.datasets.map(function (set) {
            set.pointHitRadius = 10;
            set.pointRadius = set.pointHoverRadius;
            return set;
        });
        var showError = (0, validator_1.containsInvalidDataSets)(data.datasets);
        if (options.scales) {
            var gridLineColor_1 = '#7B888F';
            options.scales.xAxes = options.scales.xAxes.map(function (x) { return (__assign(__assign({}, x), { categoryPercentage: 0.35, gridLines: data.type === 'horizontalBar'
                    ? __assign(__assign({}, x.gridLines), { color: gridLineColor_1, drawOnChartArea: true }) : __assign(__assign({}, x.gridLines), { color: gridLineColor_1 }) })); });
            options.scales.yAxes = options.scales.yAxes.map(function (x) { return (__assign(__assign({}, x), { gridLines: data.type === 'horizontalBar'
                    ? __assign(__assign({}, x.gridLines), { display: false }) : __assign(__assign({}, x.gridLines), { color: gridLineColor_1 }) })); });
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Chart_1.default, { key: data.id, id: data.id, title: data.title, type: data.type, labels: data.labels, options: options, datasets: newDatasets, palette: palette, highlightLastDataEntry: data.highlightLastDataEntry, isSmall: data.isSmall }),
            showError && (react_1.default.createElement("div", { style: { background: 'red', display: 'inline' } }, "Grafen \"".concat(data.title, "\" inneholder ugyldige datasett, vennligst sjekk at data er lagt inn riktig (f.eks: tall kan ikke ha mellomrom som tusenskille)")))));
    };
    return GraphSingleBlock;
}(react_1.default.Component));
exports.default = GraphSingleBlock;
